/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, styled, TextField } from "@mui/material";
import { NavLink } from "react-router-dom";

export const StyledFieldContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "30px",
  marginTop: "30px",
});

export const StyledLeftFieldContainer = styled(Box)({
  width: "20%",
  display: "flex",
  justifyContent: "flex-end",
});

export const StyledValue = styled('div')({
})

export const StyledTextField = styled(TextField)({
  '&:hover fieldset':{
    border: '2px solid #2b4fb9 !important',
  },
  ".MuiInputBase-root": {
    height: "40px",
  },

  "& .MuiInputAdornment-root": {
    backgroundColor: "#f0f0f0",
    padding: "20px 12px",
    borderRight: "1px solid #c4c4c4",
  },
});

export const StyledNavLink = styled(NavLink)({
  "&:hover": {
    textDecoration: "underline !important",
  },
  color: "#2b4fb9",
  textDecoration: "none",
});

const getDepartmentColorCode = (department) => {
  switch (department) {
    case "foh":
      return "#39cd80";
    case "boh":
      return "#61b2fa";
    default:
      return "#f64246";
  }
};

export const DepartmentBadge = styled(Box)(({ department }) => ({
  height: "24px",
  width: "100px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: `${getDepartmentColorCode(department)}20`,
  color: getDepartmentColorCode(department),
  fontSize: "0.775rem",
}));
